<template>
  <main>
    <div v-if="errorBuilding" class="error">Error: {{ errorBuilding }}</div>
    <transition name="fade">
      <div v-if="building">
        <div class="row">
          <div v-if="building.image1URLMedium">
            <img class="rounded-3 img-fluid" :src="building.image1URLMedium" />
          </div>
        </div>
        <div class="row">
          <h4>{{ building.name }}</h4>
          <p>{{ building.description }}</p>
        </div>
        <div class="row">
          <div class="col">
            <router-link
              :to="{
                name: 'AvailableSpace'
              }"
              ><h4>Available Space</h4></router-link
            >
            <div v-if="spaces && spaces.length > 0">
              <div v-for="space in spaces" :key="space.id">
                <router-link
                  :to="{
                    name: 'SpaceDetails',
                    params: { spaceId: space.id }
                  }"
                >
                  <div class="text-start mb-4 single">
                    <div class="row">
                      <div class="col">
                        <b>{{ space.name }}</b>
                        <div><b>Suite: </b>{{ space.suiteNumber }}</div>
                        <div><b>Rent: </b>{{ space.potentialRent }}</div>
                        <div><b>Available: </b>{{ space.availability }}</div>
                        <div><b>Size: </b>{{ space.sizeUsable }}</div>
                      </div>
                      <div class="col">
                        <img :src="space.floorPlanURLThumb" />
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div v-else>
              <p>
                Sorry, there are currently no offices available.
              </p>
              <p>
                <router-link :to="{ name: 'Contact' }">Contact us</router-link>
                to get on the waiting list.
              </p>
            </div>
          </div>
          <div class="col">
            <router-link
              :to="{
                name: 'Location'
              }"
            >
              <h4>Location</h4></router-link
            >
            <p>{{ building.locationSummary }}</p>
            <p>{{ building.address }}</p>
            <img
              v-if="googleStaticMap"
              :src="googleStaticMap"
              alt="Building Location Map"
            />
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import getBuildingByURL from "@/composables/getBuildingByURL";
import { computed, ref } from "@vue/reactivity";

export default {
  name: "Home",
  setup() {
    const googleMapsAPIKey = ref(process.env.VUE_APP_GOOGLE_MAPS_API_KEY);

    const { errorBuilding, building, spaces } = getBuildingByURL(
      window.location.host
    );

    const googleStaticMap = computed(() => {
      if (building.value) {
        return (
          "https://maps.googleapis.com/maps/api/staticmap?center=" +
          encodeURIComponent(building.value.address) +
          "&markers=color:green%7C" +
          encodeURIComponent(building.value.address) +
          "&zoom=12&size=400x400&key=" +
          googleMapsAPIKey.value
        );
      } else {
        return null;
      }
    });

    return { errorBuilding, building, spaces, googleStaticMap };
  }
};
</script>

<style scoped>
.fade-enter-from {
  opacity: 0;
}
.fade-enter-active {
  transition: all 2s ease;
}
</style>
